<div class="select-page">
  @if (userContextSvc?.currentUser?.BusinessFunctionContexts?.length == 0) {
    <ui-card styleClass="select-page__card select-page__card--error">
      <div class="select-page__header">
        <h1 class="select-page__title">Отсутствует доступ на портал!</h1>
      </div>
      <div class="select-page__body">
        <p class="select-page__text">
          Для Вашей учетной записи не назначена торговая сеть. Обратитесь к
          администратору портала или напишите на нашу почту:
          <a href="mailto:tc5portals@x5.ru">tc5portals&#64;x5.ru</a>
        </p>
        <p class="select-page__text">
          В письмо с проблемой приложите скриншот, на котором будет
          <b>видна</b> данная информация или скопируйте строку с отладочной
          информацией.
        </p>
        <p class="select-page__debug">
          Информация о пользователе: Id:{{
            userContextSvc?.currentUser?.Id
          }}
          Login:{{ userContextSvc?.currentUser?.Login }} IsIntranet:{{
            userContextSvc?.currentUser?.IsIntranet
          }}
          TradingNetwork:[{{
            userContextSvc?.currentUser?.TradingNetwork?.Id
          }}]{{ userContextSvc?.currentUser?.TradingNetwork?.Title }}
          BFContext:
          @for (
            item of userContextSvc?.currentUser?.BusinessFunctionContexts;
            track item
          ) {
            <span>[{{ item?.Id }}]{{ item?.Title }}, </span>
          }
        </p>
      </div>
    </ui-card>
  }

  @let allBfs = userContextSvc?.currentUser?.BusinessFunctionContexts;
  @let bfs = filteredBfs;
  @let selectedId = userContextSvc?.currentUser?.SelectedBF?.Id;

  @if (allBfs?.length) {
    <div class="select-page__intro">
      <h1 class="select-page__title">Выберите бизнес-функцию</h1>
      @if (intent) {
        <p class="select-page__lede">
          {{
            intent === 'idea'
              ? 'После выбора откроется форма подачи идеи.'
              : 'После выбора откроется главная страница бизнес-функции.'
          }}
        </p>
      }
    </div>

    @if (fromQuiz) {
      <div class="select-page__note">
        <i class="fas fa-info-circle"></i>
        Не удалось определить бизнес-функцию по ответам. Выберите её из списка.
      </div>
    }

    @if (allBfs.length > 5) {
      <input
        type="search"
        class="select-page__search"
        placeholder="Поиск по названию"
        [value]="searchQuery"
        (input)="onSearch($event)"
      />
    }
  }

  @if (allBfs?.length && !bfs.length) {
    <p class="select-page__empty">Ничего не нашлось. Попробуйте другое название.</p>
  }

  @if (bfs?.length) {
    <div class="bf-list">
      @for (bf of bfs; track bf.Id) {
        @let isCurrent = bf.Id === selectedId;
        @let isOpen = bf.Id === openId;
        @let isClosed = bf.AvailableIdeaCreate === false;

        <div
          class="bf-item"
          [class.bf-item--open]="isOpen"
          [class.bf-item--closed]="isClosed"
        >
          <button
            type="button"
            class="bf-item__head"
            [attr.aria-expanded]="isOpen"
            (click)="toggle(bf.Id)"
          >
            <span
              class="bf-item__tile"
              [ngClass]="'bf-item__tile--' + getAvatarTone(bf.Id)"
            >
              {{ getInitials(bf.Title) }}
            </span>

            <span class="bf-item__info">
              <span class="bf-item__title">{{ bf.Title }}</span>
              <span class="bf-item__meta">
                <span class="bf-item__status">
                  <span class="bf-item__dot"></span>
                  {{ isClosed ? 'Приём идей закрыт' : 'Приём идей открыт' }}
                </span>
                @if (isCurrent) {
                  <span class="bf-item__badge">
                    <i class="fa-solid fa-check"></i>Текущая
                  </span>
                }
              </span>
            </span>

            <i class="fa-solid fa-chevron-down bf-item__chevron"></i>
          </button>

          @if (isOpen) {
            <div class="bf-item__body">
              @if (bf.DetailedDescription) {
                <div
                  class="bf-item__description"
                  [innerHTML]="bf.DetailedDescription"
                ></div>
              } @else {
                <p class="bf-item__description bf-item__description--empty">
                  Описание бизнес-функции пока не добавлено.
                </p>
              }

              @if (intent === 'idea' && isClosed) {
                <span class="bf-item__current-note">
                  <i class="fa-solid fa-lock"></i>Приём идей в этой бизнес-функции закрыт
                </span>
              } @else if (intent === 'idea') {
                <button
                  type="button"
                  class="bf-item__go"
                  (click)="selectBF(bf)"
                >
                  <span class="bf-item__go-label">
                    Подать идею в эту бизнес-функцию<i
                      class="fa-solid fa-arrow-right"
                    ></i>
                  </span>
                </button>
              } @else if (isCurrent) {
                <span class="bf-item__current-note">
                  <i class="fa-solid fa-check"></i>Вы уже в этой бизнес-функции
                </span>
                <button
                  type="button"
                  class="bf-item__go"
                  (click)="selectBF(bf)"
                >
                  <span class="bf-item__go-label">
                    Продолжить<i class="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              } @else {
                <button
                  type="button"
                  class="bf-item__go"
                  (click)="selectBF(bf)"
                >
                  <span class="bf-item__go-label">
                    Перейти в эту бизнес-функцию<i
                      class="fa-solid fa-arrow-right"
                    ></i>
                  </span>
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  @if (hasQuiz && allBfs?.length) {
    <div class="select-page__quiz">
      Не знаете, какую выбрать?
      <button type="button" class="select-page__quiz-link" (click)="openQuiz()">
        Ответьте на пару вопросов
      </button>
    </div>
  }

  <app-loading-ui-blocker [loading]="loading" />
</div>
